// Global "creator mode" flag.
//
// The creator/edit view of each content type lives at a paired `-creator`
// route (e.g. /documents ↔ /documents-creator). Historically the per-screen
// toggle just navigated between the two. This flag makes the mode global: it
// is synced from the URL whenever a paired list route is visited (see
// routes.js) and drives the main navigation so the chosen mode carries across
// every screen.

/**
 * Content list routes that have a paired "-creator" variant. Used both to
 * sync the flag from the URL and to build mode-aware navigation links.
 */
export const CREATOR_MODE_ROUTES = new Set([
  "news",
  "events",
  "videos",
  "galleries",
  "podcasts",
  "documents",
  "training",
  "quizzes",
  "links",
  "polls",
  "forms",
  "company_directory",
  "presentations",
]);

const defaultState = {
  creatorMode: false,
};

export const creatorModeReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_CREATOR_MODE":
      return { ...state, creatorMode: !!action.payload };
    default:
      return state;
  }
};
